/**
 * #29 (ESERV2-1432) — for Heritage the action is a submission (the backend
 * routes it through CreateSalesOrder), not an email send, and the call asked
 * for the wording to say so. Any send with the Heritage API path selected
 * reads Submit; an email-only send keeps Send.
 */

export type SendActionState = {
	sendViaApi: boolean;
	isCheckingStock: boolean;
	isSending: boolean;
	confirmSendDespiteStock: boolean;
};

export function sendPurchaseOrderActionLabel({
	sendViaApi,
	isCheckingStock,
	isSending,
	confirmSendDespiteStock,
}: SendActionState): string {
	if (isCheckingStock) {
		return "Checking stock...";
	}
	if (isSending) {
		return sendViaApi ? "Submitting..." : "Sending...";
	}
	if (confirmSendDespiteStock) {
		return sendViaApi ? "Submit anyway" : "Send anyway";
	}
	return sendViaApi ? "Submit" : "Send";
}
